import React from 'react'
import { ProductPreset } from 'services/api/entities/catalog/packages/common'
import { Box } from '@mui/material'
import { getRatioMultiplier } from './RatioMultiplier'
import LocalizedSpan from 'ui-shared/LocalizedFields/LocalizedSpan'

export type ItemLabelProp = {
  label?: string
  record: ProductPreset & {
    quantityMultiplier?: number
    deliveryTimeLogic?: string
  }
  hasQuantityMultiplier?: boolean
  hasRatioMultiplier?: boolean
  children?: React.ReactNode
}

export const ProductPresetField: React.FC<ItemLabelProp> = ({
  label = 'Name: ',
  record,
  hasRatioMultiplier = false,
  children,
}) => {
  const hasQuantityMultiplier = !!record.quantityMultiplier
  return (
    <Box
      display="flex"
      justifyContent="flex-start"
      alignItems="center"
      key={record.id}
      style={{ gap: '1rem', fontSize: '1rem' }}
      marginLeft="1.5rem"
    >
      <h4>{label} </h4>
      <LocalizedSpan>{record.name}</LocalizedSpan>
      {hasQuantityMultiplier && (
        <>
          {hasRatioMultiplier ? (
            <>
              <h4>Ratio Multiplier: </h4>
              <span className="MuiTypography-body2">
                {getRatioMultiplier(record.quantityMultiplier!)}
              </span>
            </>
          ) : (
            <>
              <h4>Quantity Multiplier: </h4>
              <span>{record.quantityMultiplier}</span>
            </>
          )}
        </>
      )}
      {children}
    </Box>
  )
}
